import { useTranslation } from "react-i18next";

import { Button } from "../primitives/Button";
import type { UiTheme } from "../theme";

// The «Select» / «Done» toggle of a day's head row (#336): the phone's list
// of exercises and the wide grid's cells share it, each with its own spoken
// label (a11yIdle, a11yDone).
export function SelectToggle({
  theme,
  active,
  onPress,
  day,
  a11yIdle,
  a11yDone,
}: {
  theme: UiTheme;
  active: boolean;
  onPress: () => void;
  day: string;
  /** Spoken when it would start the selection, and when it would end it. */
  a11yIdle: { key: string; defaultValue: string };
  a11yDone: { key: string; defaultValue: string };
}) {
  const { t } = useTranslation();
  const spoken = active ? a11yDone : a11yIdle;
  return (
    <Button
      theme={theme}
      variant="ghost"
      compact
      pressed={active}
      label={active ? t("editorV3.selectDone", { defaultValue: "Done" }) : t("editorV3.select", { defaultValue: "Select" })}
      accessibilityLabel={t(spoken.key, { day, defaultValue: spoken.defaultValue })}
      onPress={onPress}
    />
  );
}
